<template>
  <div class="menu">
    <div v-if="list[0]" class="left" @click="menuClick(list[0])">
      <img :src="list[0].icon" />
      <span>{{list[0].name}}</span>
    </div>
    <div class="right flex_wrap">
      <div v-for="(item, i) in list.slice(1, 5)" class="item" @click="menuClick(item)">
        <img :src="item.icon" />
        <span>{{item.name}}</span>
      </div>
    </div>
    <!-- <div v-for="(item, i) in list" class="menu-item" @click="menuClick(item)">
      <div class="menu-item-img">
        <img :src="item.icon" />
      </div>
      <div class="menu-item-name">{{item.name}}</div>
    </div> -->
  </div>
</template>

<script>
  import {
    getUrlParam
  } from '@/util/util';
  import config from '@/config';
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      list: {
        type: Array,
        default: () => []
      },
      authToken: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapState(['code'])
    },
    methods: {
      menuClick(item) {
        console.log(item)
        this.getLogin(item)
      },
      getLogin(item) {
        let auth_token = localStorage.getItem('auth_token');
        if (!auth_token) {
          // let code = this.$route.query.code || getUrlParam('code');
          let code = this.code
          let merchant_id = localStorage.getItem('merchant_id');
          switch (this.$client) {
            case 'wxh5':
              if (!merchant_id) {
                if (code) {
                  this.$api
                    .request('Wx/grantLogin', {
                      code: code
                    })
                    .then(({
                      data
                    }) => {
                      this.$message({
                        message: "登录成功！",
                        type: "success"
                      })
                    })
                    .catch(error => {
                      this.$message({
                        message: "登录失败！",
                        type: "warning"
                      })
                      this.$router.push('/');
                    });
                } else {
                  window.location.href = config.api_url + 'Wx/grant';
                }
              } else {
                this.$confirm(' ', '需登录后操作', {
                  distinguishCancelAndClose: true,
                  confirmButtonText: '去登录',
                  showCancelButton: false,
                  customClass: 'msgBox',
                  center: true,
                  confirmButtonClass: 'confirm-btn'
                }).then((action) => {
                  this.$router.push('/login');
                }).catch(() => {});
              }
              break;
            case 'magapp':
              if (code) {
                this.$api
                  .request('System/grantLogin', {
                    code: code
                  })
                  .then(({
                    data
                  }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                    this.$router.push('/');
                  });
              } else {
                window.location.href = config.login_url;
              }
              break;
            case 'h5':
              if (!merchant_id) {
                if (code) {
                  this.$api
                    .request('System/grantLogin', {
                      code: code
                    })
                    .then(({
                      data
                    }) => {
                      this.$message({
                        message: "登录成功！",
                        type: "success"
                      })
                    })
                    .catch(error => {
                      this.$message({
                        message: "登录失败！",
                        type: "warning"
                      })
                      this.$router.push('/');
                    });
                } else {
                  this.$confirm(' ', '需登录后操作', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '去登录',
                    showCancelButton: false,
                    customClass: 'msgBox',
                    center: true,
                    confirmButtonClass: 'confirm-btn'
                  }).then((action) => {
                    window.location.href = config.login_url + '&source=0';
                  }).catch(() => {});
                }
              } else {
                this.$confirm(' ', '需登录后操作', {
                  distinguishCancelAndClose: true,
                  confirmButtonText: '去登录',
                  showCancelButton: false,
                  customClass: 'msgBox',
                  center: true,
                  confirmButtonClass: 'confirm-btn'
                }).then((action) => {
                  this.$router.push('/login');
                }).catch(() => {});
              }
              break;
            default:
              this.$message({
                message: "非法客户端！",
                type: "warning"
              })
              break;
          }
        } else {
          this.$emit('click', item)
        }
      },
    }
  }
</script>

<style>
  .confirm-btn {
    padding: 12px 70px !important;
  }

  .el-message-box--center .el-message-box__header {
    padding-top: 16px !important;
  }

  .el-message-box--center .el-message-box__title {
    justify-content: left !important;
  }

  .el-message-box--center {
    padding-bottom: 10px !important;
  }
</style>
<style lang="less" scoped>
  .menu {
  	width: 100%;
    display: flex;
    flex-direction: row;

  	.left {
  		width: 157px;
  		height: 157px;
  		border-radius: 12.5px;
  		box-shadow: 0 2px 6px rgba(119, 113, 113, 0.3);
  		background-color: #fff;
  		display: flex;
  		justify-content: center;
  		align-items: center;
  		flex-direction: column;
  		img {
  			width: auto;
  			height: 80px;
  		}
  		span {
  			font-family: 思源黑体;
  			font-size: 14px;
  			font-weight: 500;
  			margin-top: 14px;
  		}
  	}

  	.right {
  		width: calc(100% - 157px);
  		padding-left: 27.5px;
  		.item {
  			// width: 150rpx;
  			width: calc((100% - 7.5px) / 2);
  			height: 75px;
  			margin-right: 7.5px;
  			margin-top: 7.5px;
  			box-shadow: 0 2px 5px rgba(119, 113, 113, 0.25);
  			border-radius: 12.5px;
  			background-color: #fff;
  			display: flex;
  			justify-content: center;
  			align-items: center;
  			flex-direction: column;
  			&:nth-child(2n) {
  				margin-right: 0;
  			}
  			&:nth-child(-n+2) {
  				margin-top: 0;
  			}
  			img {
  				width: auto;
  				height: 30px;
  			}
  			span {
  				font-family: 思源黑体;
  				font-size: 14px;
  				font-weight: 500;
  				margin-top: 8px;
  			}
  		}
  	}
  }
</style>



// WEBPACK FOOTER //
// src/components/menu.vue